import { NgModule } from '@angular/core';
import { DependenciesModule } from '../dependencies.module';

@NgModule({
  imports: [
    DependenciesModule
  ],
  // exports: [UploadCustomerDetailComponent],
  // declarations: [UploadCustomerDetailComponent]
})
export class AdminDetailModule { }
